module.exports = __webpack_public_path__ + "media/src/images/icons/generic_user-b0c5254280162eac26689de537a297e9.svg";